'use client';

import { useAcademyViewCount } from '../hooks/use-academy-view-count';

/**
 * 학원 리스트/상세 "진입" 기준 뷰 카운트를 pathname 변경 시 한 곳에서만 수행.
 * academy 레이아웃에서 한 번만 마운트.
 */
export default function AcademyViewCountTracker() {
  useAcademyViewCount();
  return null;
}
